if (!customElements.get('ypp-sticky-cart')) {
  customElements.define('ypp-sticky-cart', class extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      if (!this.productInfo) return;
      this.addButton = this.querySelector('[data-ypp-add]');
      this.variantButton = this.querySelector('[data-ypp-variant]');
      this.priceText = this.querySelector('[data-ypp-price]');
      this.errorText = this.querySelector('[data-ypp-error]');
      this.onAdd = () => {
        const original = this.originalButton();
        if (!original || original.disabled || original.getAttribute('aria-disabled') === 'true') return;
        original.click();
        this.sync();
      };
      this.onVariant = () => {
        const picker = this.productInfo.querySelector('variant-selects');
        const target = picker || this.originalButton();
        target?.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'center'});
        const control = picker?.querySelector('select,input:not([disabled])') || target;
        control?.focus({preventScroll:true});
      };
      this.addButton.addEventListener('click', this.onAdd);
      this.variantButton.addEventListener('click', this.onVariant);
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
      };
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.schedule();
      });
      this.observer.observe(this.productInfo, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','class','hidden','value']});
      this.productInfo.addEventListener('change',this.schedule);
      this.sync();
    }
    originalButton() {
      return document.getElementById('ProductSubmitButton-' + this.dataset.sectionId);
    }
    sync() {
      const original = this.originalButton();
      const form = document.getElementById('product-form-' + this.dataset.sectionId);
      if (!original || !form) { this.hidden = true; return; }
      this.hidden = false;
      document.body.classList.add('ypp-mobile-cart-ready');
      const busy = original.classList.contains('loading');
      this.addButton.disabled = original.disabled || original.getAttribute('aria-disabled') === 'true';
      this.addButton.textContent = busy ? this.dataset.adding : original.querySelector('span')?.textContent.trim() || original.textContent.trim();
      this.addButton.setAttribute('aria-busy',String(busy));
      const price = document.getElementById('price-' + this.dataset.sectionId);
      const sale = price?.querySelector('.price--on-sale');
      const amount = sale ? price.querySelector('.price__sale .price-item--sale') : price?.querySelector('.price__regular .price-item--regular');
      if (amount) this.priceText.textContent = amount.textContent.trim();
      const variantJSON = this.productInfo.querySelector('variant-selects [data-selected-variant]');
      if (variantJSON && this.dataset.defaultVariant !== 'true') {
        try {
          const variant = JSON.parse(variantJSON.textContent);
          this.variantButton.textContent = variant?.title || this.dataset.options;
          if (!variant) this.priceText.textContent = '';
        } catch { this.variantButton.textContent = this.dataset.options; }
      }
      const sourceError = this.productInfo.querySelector('product-form .product-form__error-message-wrapper');
      const message = sourceError && !sourceError.hidden ? sourceError.querySelector('.product-form__error-message')?.textContent.trim() : '';
      this.errorText.textContent = message || '';
      this.errorText.hidden = !message;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.productInfo?.removeEventListener('change',this.schedule);
      this.addButton?.removeEventListener('click',this.onAdd);
      this.variantButton?.removeEventListener('click',this.onVariant);
      if (this.frame) cancelAnimationFrame(this.frame);
      if (!document.querySelector('ypp-sticky-cart:not([hidden])')) document.body.classList.remove('ypp-mobile-cart-ready');
    }
  });
}
